import { Board } from './RoomsCollection'

export function getRoomsByName(rooms: Board[]) {
  const roomsNames = rooms.map(room => room.roomName)
  const uniqueNames = [...new Set(roomsNames)]

  const roomsSortedByName = uniqueNames
    .map(uniqueName => rooms.filter(room => room.roomName === uniqueName))
    .flat()
    .map((room, index) => ({ ...room, position: index + 1 }))

  return uniqueNames.map(uniqueName =>
    roomsSortedByName.filter(room => room.roomName === uniqueName)
  )
}
